// /**
//  * Users - list
//  */

// React
import React from 'react';

// UI

import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';

// Icon
// import Icon from '@mdi/react';
// import {
//   mdiClose,
//   mdiFileDocumentOutline,
//   mdiPencilOutline,
//   mdiCheck,
// } from '@mdi/js';

// Helper
import {translateOrderStatus} from '../../../utils/helpers';

import jMoment from 'moment-jalaali';
// Type
import {ReportsCurrentOrders} from '../interfaces';

type Data = ReportsCurrentOrders;
type Props = {
  data: any;
};

type Ord = 'asc' | 'desc';
interface HeadCell {
  // id: keyof Data;
  id: any;
  label: string;
}
interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  statuses: any;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: {[key in Key]: number | string},
  b: {[key in Key]: number | string}
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array?.map((el, index) => [el, index] as [T, number]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis?.map(el => el[0]);
}

function EnhancedTableHead(props: EnhancedTableProps) {
  return (
    <TableHead>
      <TableRow>
        <StyledTableCell align="center"> تاریخ</StyledTableCell>
        {props.statuses?.map((headCell: any, index: number) => (
          <StyledTableCell key={index} align="center">
            {translateOrderStatus(headCell)}
          </StyledTableCell>
        ))}
        <StyledTableCell align="center"> مجموع</StyledTableCell>
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const classes = useStyles();
  const [order] = React.useState<Ord>('desc');
  const [orderBy] = React.useState<any>('id');
  const [dense] = React.useState(false);

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <EnhancedTableHead classes={classes} statuses={props.data.statuses} />

          <TableBody>
            {stableSort(props.data.days, getComparator(order, orderBy))
              ?.slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow key={index}>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {jMoment(row.date, '')
                        .locale('fa')
                        .format(`jD jMMMM jYY`)}
                    </TableCell>
                    {row.values.map((value: any) => (
                      <TableCell align="center">{value}</TableCell>
                    ))}
                    <TableCell align="center">
                      {row.values.reduce((a: number, b: number) => a + b)}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
